export default __webpack_public_path__ + "static/media/oneplace_kys.b774b403.jpg";